export enum MilestoneCategory {
  GOVERNANCE_T1 = 'GOVERNANCE_T1',
  GOVERNANCE_T2 = 'GOVERNANCE_T2',
  GOVERNANCE_T3 = 'GOVERNANCE_T3',
  COMMON_ACTIVITIES = 'COMMON_ACTIVITIES',
  PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT',
  LAND = 'LAND',
  PERMIT = 'PERMIT',
  GRID = 'GRID',
  WIND = 'WIND',
  YIELD = 'YIELD',
  CONTRACTS = 'CONTRACTS',
  PROJECT_ECONOMICS = 'PROJECT_ECONOMICS',
  OTHER = 'OTHER',
  CONSTRUCTION = 'CONSTRUCTION',
}
export const categoryToLabel = {
  [MilestoneCategory.GOVERNANCE_T1]: 'Governance - Tier 1',
  [MilestoneCategory.GOVERNANCE_T2]: 'Governance - Tier 2',
  [MilestoneCategory.GOVERNANCE_T3]: 'Governance - Tier 3',
  [MilestoneCategory.COMMON_ACTIVITIES]: 'Common Activities',
  [MilestoneCategory.PROJECT_MANAGEMENT]: 'Project Management',
  [MilestoneCategory.LAND]: 'Land',
  [MilestoneCategory.PERMIT]: 'Permit',
  [MilestoneCategory.GRID]: 'Grid',
  [MilestoneCategory.WIND]: 'Wind',
  [MilestoneCategory.YIELD]: 'Energy Yield',
  [MilestoneCategory.CONTRACTS]: 'Contracts',
  [MilestoneCategory.PROJECT_ECONOMICS]: 'Project Economics',
  [MilestoneCategory.OTHER]: 'Other',
  [MilestoneCategory.CONSTRUCTION]: 'Construction',
};
export const categoryToSimplifiedLabel = {
  ...categoryToLabel,
  [MilestoneCategory.GOVERNANCE_T1]: 'Governance',
  [MilestoneCategory.GOVERNANCE_T2]: 'Governance',
  [MilestoneCategory.GOVERNANCE_T3]: 'Governance',
};
export const categoryToIcon = {
  [MilestoneCategory.GOVERNANCE_T1]: 'milestone_governance',
  [MilestoneCategory.GOVERNANCE_T2]: 'milestone_governance',
  [MilestoneCategory.GOVERNANCE_T3]: 'milestone_governance',
  [MilestoneCategory.COMMON_ACTIVITIES]: 'milestone_common_activities',
  [MilestoneCategory.PROJECT_MANAGEMENT]: 'milestone_project_management',
  [MilestoneCategory.LAND]: 'milestone_land',
  [MilestoneCategory.PERMIT]: 'milestone_permit',
  [MilestoneCategory.GRID]: 'milestone_grid',
  [MilestoneCategory.WIND]: 'milestone_wind',
  [MilestoneCategory.YIELD]: 'milestone_yield',
  [MilestoneCategory.CONTRACTS]: 'milestone_contracts',
  [MilestoneCategory.PROJECT_ECONOMICS]: 'milestone_project_economics',
  [MilestoneCategory.OTHER]: 'milestone_other',
};
export function getCategoryIndex(category: MilestoneCategory): number {
  return Object.values(MilestoneCategory).indexOf(category);
}
